import { GET_TABLE } from '../site/site-table/table.ui.store';
import { TPoint } from './points.model';

let selectedPoints: string[] = [];

export function getSelectedPoints(): string[] {
  return selectedPoints;
}

export function clearSelectedPoints(): void {
  selectedPoints = [];
}

export function setSelectedPoints(points: string[]): void {
  const table = GET_TABLE();

  selectedPoints = points;

  if (table) {
    table.selectedPoints = new Set(points);

    if (table.hasSelectedAllPoints) {
      table.tableHead.selectPoints();
    } else {
      table.tableHead.deselectPoints();
    }
  }
}

export function addSelectedPoint(_id: string): void {
  const table = GET_TABLE();

  if (!selectedPoints.includes(_id)) {
    selectedPoints.push(_id);

    if (table.hasSelectedAllPoints) {
      const workspace = table.pointSearchService.getAPIKey();

      table.setSelectedPointsCount(table.pointSearchService.getTotalCount(workspace));
    }
  }
}

export function removeSelectedPoint(_id: string): void {
  const pointIndex = selectedPoints.indexOf(_id);
  const table = GET_TABLE();

  if (pointIndex !== -1) {
    selectedPoints.splice(pointIndex, 1);
  }

  if (!table) {
    return;
  }

  if (table.selectedPoints.has(_id)) {
    table.selectedPoints.delete(_id);
  }

  const workspace = table?.pointSearchService?.getAPIKey();

  const totalPointsCount = table.pointSearchService.getTotalCount(workspace);

  if (table.selectedPointsCount === totalPointsCount) {
    table.tableHead.selectPoints();
  } else {
    table.tableHead.deselectPoints();
  }

  if (table.hasSelectedAllPoints) {
    table.isPointsSelectAllIndeterminate = true;

    table.deselectedPoints.add(_id);

    const total = table.pointSearchService.getTotalCount(workspace);

    table.setSelectedPointsCount(total - table.deselectedPoints.size);
  } else {
    if (table.isPointInSelectedGroup(_id)) {
      table.deselectedPoints.add(_id);
    }

    table.recomputeSelectedPointsCount();
  }
}

export function togglePoint(point: TPoint): boolean {
  if (point) {
    const table = GET_TABLE();

    const selectedPointsIds = getSelectedPoints();
    const pointSelected = selectedPointsIds.includes(point._id);

    if (pointSelected) {
      if (table.hasSelectedAllPoints) {
        table.isPointsSelectAllIndeterminate = true;
      }
      removeSelectedPoint(point._id);

      return false;
    } else {
      addSelectedPoint(point._id);

      table.deselectedPoints.delete(point._id);

      if (!table.hasSelectedAllPoints) {
        table.recomputeSelectedPointsCount();
      } else {
        const workspace = table.pointSearchService.getAPIKey();
        const total = table.pointSearchService.getTotalCount(workspace);

        table.setSelectedPointsCount(total - table.deselectedPoints.size);
      }

      if (table.deselectedPoints.size === 0 && table.hasSelectedAllPoints) {
        table.isPointsSelectAllIndeterminate = false;
      }

      return true;
    }
  }

  return false;
}
